<template>
  <ElRow type="flex" justify="center" class="footer">
    <ul>
      <li v-for="(item, index) in availableLocales" :key="index">
        <a @click="changeLanguage(item.code)">{{ $t(item.label) }}</a>
      </li>
    </ul>
  </ElRow>
</template>
<script>
import { languages } from '@/i18n/language';

export default {
  data() {
    return {
      locales: [
        {
          code: 'en',
          label: 'english',
        },
        {
          code: 'ru',
          label: 'russian',
        },
        {
          code: 'uk',
          label: 'ukrainian',
        },
        {
          code: 'ja',
          label: 'japanese',
        },
      ],
    };
  },

  computed: {
    availableLocales() {
      return this.locales.filter(locale => languages.includes(locale.code));
    },
  },

  methods: {
    changeLanguage(lang) {
      this.$cookies.set('user_language', lang);
      localStorage.setItem('vuejs_locale', JSON.stringify({ value: lang, expire: null }));

      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 20px 0;

  ul {
    margin: 0;
    outline: 0;
    padding: 0;
  }

  li {
    display: inline;
    padding: 0 20px 0 16px;
    background-size: 4px 5px;
    background-position: 100% 9px;
    background-repeat: no-repeat;
  }

  a {
    color: #c7cdd6;
    font-weight: normal;
    font-size: 12px;
    text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.5);
  }

  a:hover {
    cursor: pointer;
    color: #798391;
  }
}
</style>
